/// <reference path="../../_ext/Editors/MFGTransItemEditorDialog.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptItemsDialog extends _Ext.MFGTransItemEditorDialog<JobWorkReceiptItemsRow> {
        protected getFormKey() { return JobWorkReceiptItemsForm.formKey; }
        protected getLocalTextPrefix() { return JobWorkReceiptItemsRow.localTextPrefix; }
        protected getNameProperty() { return JobWorkReceiptItemsRow.nameProperty; }
        //protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEditorDialogOptions); }
        public departmentid: number;
        public form = new JobWorkReceiptItemsForm(this.idPrefix);

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        public LotNo: any;

        // #endregion 
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initMFGBOMEditor(this, this.form.BOMDetails, Config);
            q.initMFGLaborEditor(this, this.form.LaborDetails, Config);
            //q.initDetailEditor(this,this.form.NewBOMDetails, Config);
            q.hideCategorylinks(this.element);
            q.SetCategoryFullWidth(this.form.ProductCode);
            //q.SetCategoryFullWidth(this.form.BOMDetails);

            q.setTextRightAlign(this.form.FromWeight);
            q.setTextRightAlign(this.form.FromNetWeight);
            q.setTextRightAlign(this.form.FromPieces);;

            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.NewBOMDetails);
            q.hideEditorLabel(this.form.LaborDetails);
            q.hideEditorLabel(this.form.Button);
            q.HideCategoryLable(this.form.BOMDetails.element);
            //q.hideEditorToolbar(this.form.BOMDetails);
            q.hideEditorToolbar(this.form.NewBOMDetails);

            this.form.BagNo.changeSelect2(e => {

                var partyid = parseInt((this.parentEditor.parentDialog as JobWorkReceiptDialog).form.PartyId.value);
                this.form.BOMDetails.cleardata();
                let Item: WIPMovementRow;
                WIPMovementSelectService.List({ BagNo: this.form.BagNo.value, PartyId: partyid }, response => Item = response.Entities[0], { async: false });

                if (Item != null) {
                    this.setValues(Item);
                }
                else {
                    q.Alert("No Data", "No Data found for entered Bag No", 2500, false);
                }

            });


            this.form.FromWeight.changeSelect2(e => {
                var cts = 0; var gms = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                    }
                }
                var self = this;
                this.form.BOMDetails.getItems().forEach(function (item) {
                    if (item.ItemTypeId == 104 && item.CategoryId != 7) {
                        item.Weight = self.form.FromWeight.value - gms - (cts / 5);
                        item.PureWeight = (self.form.FromWeight.value - gms - (cts / 5)) * item.Purity;
                        var id = self.form.BOMDetails.getId(item);
                        self.form.BOMDetails.view.updateItem(id, item);
                    }
                });

                this.form.FromNetWeight.value = this.form.FromWeight.value - gms - (cts / 5);
                this.form.BOMDetails.refresh();

            });

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });


            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            var fieldEditor: JQuery = this.form.BagNo.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
            this.form.Button.onClick = (e) => {
                this._QCEditorClick(e);
            };
        }
        protected _QCEditorClick(e: any): void {
            if (!this.isViewMode()) {
                var allqcvalues = [];
                var getitemqcvalues = this.form.QualityInspection.getItems();
                if (getitemqcvalues.length > 0) {
                    allqcvalues = getitemqcvalues
                } else {

                    var processid = parseInt(this.form.ProcessId.value);

                    let processqcvalues: OMS.ProcessInspectionRow[];
                    if (processid > 0) {
                        OMS.ProcessInspectionService.GetProcessQCList({ ProcessId: processid }
                            , response => {
                                processqcvalues = response.Entities
                            }
                            , { async: false });
                    }
                    let productqcvalues;
                    OMS.ProductInspectionService.GetProductQCList({ ProcessId: processid, ProductId: parseInt(this.form.ProductId.value) }
                        , response => {
                            if (response.Entities.length > 0)
                                productqcvalues = response.Entities
                             
                        }

                        , { async: false });
                    if (productqcvalues != undefined) {

                        for (var i = 0; i < productqcvalues.length; i++) {
                            allqcvalues.push(productqcvalues[i]);
                        }
                    }
                    if (processqcvalues != undefined) {
                        //Remove Similar QC from Process
                        for (let j = 0; j < allqcvalues.length; j++) {
                            processqcvalues = processqcvalues.filter(x => x.ProcessId != allqcvalues[j].ProcessId);
                        }
                        for (var i = 0; i < processqcvalues.length; i++) {
                            allqcvalues.push(processqcvalues[i]);
                        }
                    }
                }
                var options = { QCValues: allqcvalues }
                var dialog = new Common.ProcessQIDialog(options);
                dialog.dialogOpen();

                dialog.element.bind('dialogclose', () => {

                    var isclosed = dialog.checksuccess;
                    if (isclosed) {
                        var qclist = dialog.qclist;
                        var validateallqc = true;
                        this.form.QualityInspection.setData(qclist);
                        for (var i = 0; i < qclist.length; i++) {
                            if (qclist[i].Status == false || qclist[i].Status == undefined)
                                validateallqc = false
                        }
                        if (validateallqc) {
                            this.form.QualityInspectionValue.value = "1";
                            //q.showAndSetRequiredField(this.form.ToDeptId);
                        }
                        else {
                            this.form.QualityInspectionValue.value = "0";
                            //this.form.ToDeptId.value = this.form.FromDeptId.value;
                            //q.readonlyEditor(this.form.ToDeptId.element, true);
                            //this.form.ToProcessId.WorkshopId = Q.parseInteger(this.form.ToDeptId.value);
                            //this.form.ToProcessId.updateItems();
                            //q.showAndSetRequiredField(this.form.ToProcessId);
                            //q.showAndSetRequiredField(this.form.ToWorkerId);
                        }


                    }
                });
            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }
        protected inplaceSearchClick(e: any): void {

            if (!this.isViewMode()) {
                var grid = WIPMovementSelectGrid;
                var partyid = parseInt((this.parentEditor.parentDialog as JobWorkReceiptDialog).form.PartyId.value);

                var filters: _Ext.SelectGridFilters = {
                    PartyId: partyid,
                    DepartmentId: parseInt(this.form.FromDeptId.value)
                }

                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Work Order", GridFilters: filters
                });

                pickerDialog.onSuccess = (selectedItems: WIPMovementRow[]) => {
                    let Item = selectedItems.shift();
                    if (Item != null) {
                        this.setValues(Item);
                    }
                    else {
                        q.Alert("No Data", "No Data found for entered Bag No", 2500, false);
                    }
                }
                pickerDialog.dialogOpen();

            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }

        getItem() {
            return this.getSaveEntity();
        }

        setValues(Item: WIPMovementRow) {
            if (Item != null) {
                this.form.BagNo.value = Item.BagNo;
                this.form.FromDeptId.value = Item.DepartmentId.toString();
                this.form.FromPieces.value = Item.Pieces;
                this.form.ProductId.value = Item.ProductId.toString();

                this.form.Line_No.value = Item.Line_No.toString();
                this.form.AttributeId.value = Item.AttributeId.toString();
                this.form.ProductCode.value = Item.ProductCode;
                this.form.Attribute.value = Item.Attribute;
                this.form.TransDate.value = Item.TransDate;
                this.form.VoucherNo.value = Item.VoucherNo;
                this.form.FromNetWeight.value = Item.NetWeight;
                this.form.Purity.value = Item.Purity;
                this.form.PureWeight.value = Item.PureWeight;
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.RefTransId.value = Item.TransId.toString();
                this.form.RefTransItemId.value = Item.TransItemId.toString();
                this.form.RefVoucherId.value = Item.RefVoucherId;
                this.form.OrderTypeId.value = Item.OrderTypeId;
                this.form.OrderTransId.value = Item.OrderId;
                this.form.OrderTransItemId.value = Item.RefTransItemId;

                this.form.Parts.value = Item.Parts;
                this.form.SubBagNo.value = Item.SubBagNo;
                this.form.TreeId.value = Item.TreeId == null ? "0" : Item.TreeId.toString();
                this.form.TreeItemId.value = Item.TreeItemId == null ? "0" : Item.TreeItemId.toString();
                this.form.TreeNo.value = Item.TreeNo;

                if (Item.OrderTypeId == 16) {
                    let salesdetails: SalesOrder.SalesOrderRow;
                    SalesOrder.SalesOrderService.GetCustomerandProductDetails({ EntityId: Item.OrderId }, response => salesdetails = response.Entity, { async: false });
                    this.form.OrderNo.value = salesdetails.VoucherNo;
                    this.form.CustomerName.value = salesdetails.LedgerName;

                } else if (Item.OrderTypeId == 47) {

                    let posdetails: Retail.POSOrderRow;
                    Retail.POSOrderService.GetCustomerandProductDetails({ EntityId: Item.OrderId }, response => posdetails = response.Entity, { async: false });
                    this.form.OrderNo.value = posdetails.VoucherNo;
                    this.form.CustomerName.value = posdetails.CustomerName;
                }
                var bomdetails: Stock.JobTransactionRow[];
                Stock.JobTransactionService.CustomJobReceiptValues({ BagNo: this.form.BagNo.value, LedgerId: this.PartyId }, function (response) {
                    return bomdetails = response.Entities;
                }, { async: false });


                var newbomdetails = [];
                for (var i = 0; i < bomdetails.length; i++) {
                    var value = bomdetails[i];

                    var newbom: JobWorkReceiptBOMRow = {
                        AttributeId: value.AttributeId,
                        ItemTypeId: value.ItemTypeId,
                        CalcOnId: value.CalcOnId,
                        ProductCode: value.ProductCode,
                        Attribute: value.Attribute,
                        BomProductId: value.ProductId,
                        BagNo: value.BagNo,
                        LotNo: value.LotNo,
                        ProductId: value.ProductId,
                        Pieces: value.Pieces,
                        Line_No: value.Line_No,
                        PureWeight: value.PureWeight,
                        Purity: value.Purity == null ? 0 : value.Purity,
                        Weight: value.Weight,
                        RefTransId: value.TransId,
                        RefVoucherId: value.VoucherTypeId,
                        StoneColorId: value.StoneColorId,
                        SieveId: value.SieveId,
                        ShapeId: value.ShapeId,
                        QualityId: value.QualityId,
                        StoneSizeId: value.StoneSizeId,
                        IsCustomerItem: value.IsCustomerItem

                    };
                    newbomdetails.push(newbom);
                }
                this.form.BOMDetails.setdata(newbomdetails);
                var exchrate = (this.parentEditor.parentDialog as JobWorkReceiptDialog).form.ExchRate.value;
                this.ExchangeRate = exchrate == null ? 1 : exchrate;
                this.CalculateTotals();
                var LaborRate = 0;
                var labordetail = [];
                var laborcaloptions: RateHelper.LaborCalOptions = {
                    ProductId: parseInt(this.form.ProductId.value),
                    AttributeId: parseInt(this.form.AttributeId.value),
                    RateListId: 0,
                    Markup: 0,
                    Pieces: this.form.FromPieces.value,
                    Weight: this.form.FromWeight.value,
                    NetWeight: this.form.FromNetWeight.value,
                    TransDate: this.TransDate,
                    IsWastage: false,
                    SettingId: 0,
                    IsCustomerItem: false
                }
                var ItemLabor: Purchase.PurchaseLaborRow[] = RateHelper.GetPurchseLabour(laborcaloptions);
                if (ItemLabor.length > 0) {
                    for (var i = 0; i < ItemLabor.length; i++) {
                        ItemLabor[i].LabourRate = ItemLabor[i].LabourRate / this.ExchangeRate;
                        ItemLabor[i].LabourAmount = ItemLabor[i].LabourAmount / this.ExchangeRate;
                        ItemLabor[i].CCLabourAmount = ItemLabor[i].LabourAmount;
                        LaborRate += ItemLabor[i].LabourAmount;
                        labordetail.push(ItemLabor[i]);
                    }
                }
                this.form.LaborDetails.setdata(labordetail);
            }
        }


        public CalculateTotals() {

            var LaborRate = 0;
            var labordetail = [];
            var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
            for (var k of this.form.BOMDetails.getItems()) {

                if (k.ItemTypeId == 104) {
                    Wt += Q.parseDecimal(k.Weight.toString());
                    q.showAndEnableField(this.form.FromWeight);
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                    cts += k.Weight;
                    diapcs += k.Pieces
                }
                if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                    gms += k.Weight;
                    clrpcs += k.Pieces;
                }

            }
            //alert(cts + '');
            if (cts > 0) {
                var carats = cts / 5;
                var GrsWt = Wt + gms + carats;
                this.form.FromWeight.value = GrsWt;
            }
            else
                this.form.FromWeight.value = Wt + gms;

            this.form.FromNetWeight.value = Wt;


        }

        public SetMaterialInData(item: JobWorkReceiptBOMRow, issueditem: Stock.JobTransactionRow) {
            if (item.ItemTypeId == 105) {
                issueditem.Weight = (issueditem.Pieces - item.Pieces) * issueditem.PointerWeight;
                issueditem.Pieces = issueditem.Pieces - item.Pieces;
            }
            else {
                issueditem.Weight = issueditem.Weight - item.Weight;
                issueditem.Pieces = issueditem.Pieces - item.Pieces;
            }

            this.form.NewBOMDetails.setBOMData(issueditem);
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            this.PartyId = parseInt((this.parentEditor.parentDialog as JobWorkReceiptDialog).form.PartyId.value);

            if (isNaN(this.PartyId)) {
                q.alert('', 'Please Select Party', true, 2999);
                this.dialogClose();
                return
            }
            if (this.form.BagNo.value == "") {
                //    this.form.NewBOMDetails.BOMProductIds = this.form.BOMDetails.getItems();
                //}

                this.PartyId = parseInt((this.parentEditor.parentDialog as JobWorkReceiptDialog).form.PartyId.value);
                if (this.PartyId == null || this.PartyId == 0) {
                    q.alert('', 'Please select Party to continue', true, 2999);
                    this.dialogClose();
                    return;
                }
            }
            var x = this.form.BOMDetails.getItems();
            var y = this.form.NewBOMDetails.getItems();

        }
        protected validateBeforeSave() {
            super.validateBeforeSave();
            var oldbom = this.form.BOMDetails.getItems();
            var materialin = this.form.NewBOMDetails.getItems();



            return true;
        }
    }
}